import Spinner from "vue-simple-spinner";
import Vue from "vue"
// import VeeValidate from 'vee-validate';
// Vue.use(VeeValidate, { fieldsBagName: 'veeFields', events: '' });
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", {
	...required,
	message: "This field is required"
});
extend("email", {
	...email,
	message: "Please enter a valid email address"
});
extend('password', {
	params: ['target'],
	validate(value, { target }) {
		return value === target;
	},
	message: 'Password confirmation does not match'
});


export default {
	components: {
		ValidationProvider,
		ValidationObserver,
		Spinner
	},
	props: ["accounts", "usrid", "acls", "standardoptions"],

	data() {
		return {
			account: {
				"USR_ID": 0,
				"USR_NAME": '',
				"USR_LOGIN": '',
				"USR_EMAIL": '',
				"USR_PWD_NEW": ''
			},
			rolearr: [],
			clientacls: [],
			confirmation: '',
			spinner: false
		};
	},
	created: function () {
		let that = this;
		console.log(this.acls)
		// this.rolearr = this.acls.roles.map(({ id, role }) => ({
		// 	value: id,
		// 	text: role
		// }));
		// this.rolearr = this.acls.roles.reduce((acc, ele) =>  useroles.includes(ele.id) ? acc.concat({"value": ele.id, "text":ele.role}): acc ,[]);
		// console.log(devReact);
		this.rolearr = this.acls.roles.filter(obj => !obj.role.match(/:userid/))
			.map(({ id, role }) => ({
				value: id,
				text: role
			}));
		if (this.usrid === 0) {
			console.log('new user')
		}
		else {
			this.$http
				.get("/account/single?USR_ID=" + this.usrid, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("shareXToken")
					}
				})
				.then(resp => {
					if (resp.data.error) {
						alert("Connection failed: " + resp.data.error);
						//resolve({'loginError':resp.data.error})
					} else {
						that.account = resp.data.user;
						that.clientacls = resp.data.acls;
					}
				})
				.catch(err => {
					// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
					alert(err);
					this.loading = false;
				});
		}
	},
	methods: {
		assertDelete() {
			if (confirm("Are you sure you want to remove this Account?")) {
				this.deleteAccount();
			}
		},
		matchRole(res, role, priv) {
			let str = res + "-" + role + "-" + priv;
			return this.clientacls.includes(str) ? "active" : "passive";
		},

		updatePerm(res, role, priv) {
			let str = res + "-" + role + "-" + priv;
			console.log("passed ", str);
			const index = this.clientacls.indexOf(str);
			if (index !== -1) {
				console.log("remove ", str);
				this.clientacls.splice(index, 1);
			} 
			else {
				this.clientacls.push(str);
				console.log("push ", str);
				// if we add a global perm we must remove the accompanying private one
				let theother = priv == "0" ? "1" : "0";
				let theotherstr = res + "-" + role + "-" + theother;
				const theotherindex = this.clientacls.indexOf(theotherstr);
				if (theotherindex !== -1) {
					console.log("remove private ", theotherstr);
					this.clientacls.splice(theotherindex, 1);
				}
			}
		},

		togglePermissions(resid) {
			const regstr = "^" + resid;
			const newreg = new RegExp(regstr)
			let resroles = this.clientacls.filter(ent => ent.match(newreg))
	    this.removeRoleFromClientPerms(resid)
			const useroles = [1,3,5,7];

			// Mark all
			if(resroles.length < 4) {
				useroles.forEach((rid) => { 
					this.clientacls.push(`${resid}-${rid}-0`)
				 })
			}
			//unmark all
			else {

			}
		},

		removeRoleFromClientPerms(resid) {
			const regstr = "^" + resid;
			const newreg = new RegExp(regstr)
			for(let i=0;i < this.clientacls.length;i++) {
				if(newreg.test(this.clientacls[i])) {
					this.clientacls.splice(i,1);
					i--;
				}
			}
		},

		transmitForm() {
			var formfields = [
				"USR_ID",
				"USR_NAME",
				"USR_LOGIN",
				"USR_EMAIL",
				"USR_PWD_NEW",
			];
			let transfer = {};
			for (var i = 0; i < formfields.length; i++) {
				transfer[formfields[i]] = this.account[formfields[i]];
			}
			this.updateAccount(transfer)
		},

		updateAccount(entry) {
			var that = this
			this.spinner = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/account/edit', entry, headers)
				.then(function (response) {
					that.spinner = false;
					let msg = (that.account.USR_ID > 0) ? 'User edited' : 'User added'
					if (response.data['ID'] != '') {
						entry['USR_ID'] = parseInt(response.data['ID'])
						that.accounts.unshift(entry)
						that.account.USR_ID = entry['USR_ID']
					}
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: msg,
						position: "toast-top-center",
						type: "success"
					});
					console.log(response)
				})
				.catch(function (error) {
					that.spinner = false;
					alert("There was an error processing your request.")
					console.log(error)
				})
			// alert(entry.s_id + "!!")
		},

		deleteAccount() {
			var that = this
			console.log("deleting")
			let payload = { 'USR_ID': this.account.USR_ID }
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/account/delete', payload, headers)
				.then(function (response) {
					console.log(response)
					for (var i = 0; i < that.accounts.length; i++) {
						if (that.accounts[i].USR_ID == that.account.USR_ID) {
							that.accounts.splice(i, 1)
						}
					}
					that.showeditor = false;
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: "Deletion successful",
						position: "toast-top-center",
						type: "success"
					});
				})
				.catch(function (error) {
					that.spinner = false;
					alert("There was an error processing your request.")
					that.showeditor = false;
					console.log(error)
				})
			// alert(sid + "!!")
		},

		setPermissions() {
			let that = this
			this.spinner = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/account/setacls', { 'USR_ID': this.account.USR_ID, 'acls': this.clientacls }, headers)
				.then(function (response) {
					that.spinner = false;
					console.log(response)
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: "Permissions set",
						position: "toast-top-center",
						type: "success"
					});
				})
				.catch(function (error) {
					that.spinner = false;
					alert("There was an error processing your request.")
					console.log(error)
				})
		}
	}
};
